export enum RESET_PASSWORD {
    LINK_HAS_BEEN_SENT_TO = 'LINK_HAS_BEEN_SENT_TO',
    LOGIN_RESET_LINK_BUTTON = 'LOGIN.RESET_LINK_BUTTON',
    LOGIN_RESET_LINK_TEXT = 'LOGIN.RESET_LINK_TEXT',
}
